import React from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography, Select, Button, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import TextLoop from 'react-text-loop';
import { ReactComponent as TogetherSvg } from '../../../assets/icons/together.svg';
import { ReactComponent as GoogleSvg } from '../../../assets/icons/google-colour.svg';
import { ReactComponent as FacebookSvg } from '../../../assets/icons/facebook.svg';
import useChangeLanguage from '../../../containers/hooks/useChangeLanguage';
import { ReactComponent as MedicineSvg } from '../../../assets/icons/medicine.svg';
import LoginForm from '../../../components/mobile/LoginForm';

const { Title } = Typography;

const styles = {
  title: {
    margin: '35px 0px',
    whiteSpace: 'pre-line',
    fontSize: '20px',
    color: '#262626',
    fontWeight: '400'
  },
  welcomeTitle: {
    margin: '15px 0 25px',
    whiteSpace: 'pre-line',
  },
  rowButton: {
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  privacy: {
    fontSize: 14,
    fontWeight: 28,
    color: '#999999',
    margin: 0
  },
};

function SignInSelect() {
  const { t } = useTranslation(['common', 'welcome']);
  const history = useHistory();
  const { lang, langOptions, changeLanguage } = useChangeLanguage();

  const onChange = (value) => {
    const [language, direction] = value;
    changeLanguage(language, direction);
  };

  const onBack = () => {
    history.push('/sign-in');
  }

  const onLoginWithEmail = () => {
    history.push('/login');
  };

  const onLoginWithPhone = () => {
    history.push('/login-phone');
  };

  const onLoginWithGoogle = () => {

  }

  const onLoginWithFacebook = () => {

  }

  return (
    <Box position="relative">
      <Box paddingTop={30} paddingBottom={12} paddingX={20}>
        <Row justify="center" style={{ padding: 0, marginBottom: 25 }}>
          <img
            alt="AlemHealth"
            src={`${window.location.origin  }/alem_health_logo.png`}
            style={{
              objectFit: 'contain',
              margin: 0,
              padding: 0,
              height: 40,
            }}
          />
        </Row>
        <Row type="flex" align="middle" gutter={24} style={{ width: '100%' }}>
          <Col>
            <div className="language-label">
              <TextLoop>
                {langOptions.map(({ value }) => (
                  <Title key={value} level={4} style={styles.welcomeTitle}>
                    {t(`common:language.title.${value}`)}
                  </Title>
                ))}
              </TextLoop>
            </div>
          </Col>
          <Col flex={1}>
            <div>
              <Select
                style={{ width: '90%' }}
                size="large"
                value={t(`common:language.${lang}`)}
                onChange={onChange}
              >
                {langOptions.map(({ value, direction }) => (
                  <Select.Option key={value} value={[value, direction]}>
                    {t(`common:language.${value}`)}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>
        <Box display="flex" justifyContent="center">
          <TogetherSvg style={{ margin: '20', maxWidth: '80%' }} />
        </Box>
        <Box textAlign="center">
          <Row gutter={[0, 24]}>
            <Col xs={24}>
              <Title level={4} style={styles.title}>
                {t('welcome:signIn.welcome')}
              </Title>
              <br />
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button
                  htmlType="button"
                  type="primary"
                  size="large"
                  onClick={onLoginWithEmail}
                  block
                >
                  {t('welcome:signIn.loginWithEmail')}
                </Button>
                <Button
                  htmlType="button"
                  type="primary"
                  size="large"
                  onClick={onLoginWithPhone}
                  block
                >
                  {t('welcome:signIn.loginWithPhone')}
                </Button>
                {/* <Button
                  htmlType="button"
                  type="primary"
                  size="large"
                  onClick={onLoginWithGoogle}
                  block
                  ghost
                >
                  <p style={styles.rowButton}>
                    <GoogleSvg style={{ marginRight: 5 }}/>{t('welcome:signIn.loginWithGoogle')}
                  </p>
                </Button>
                <Button
                  htmlType="button"
                  type="primary"
                  size="large"
                  onClick={onLoginWithFacebook}
                  block
                  ghost
                  style={{alignItems: 'center'}}
                >
                  <p style={styles.rowButton}>
                    <FacebookSvg style={{ marginRight: 5 }}/>{t('welcome:signIn.loginWithFacebook')}
                  </p>
                </Button> */}
              </Space>
            </Col>
          </Row>
          <br />
          <Row justify="center" style={{ padding: 0, marginBottom: 25 }}>
            <Col xs={24}>
              <Button type="link" onClick={onBack}>
                <p style={styles.rowButton}>
                  <ArrowLeftOutlined style={{ color: '#15A9E1', marginRight: 10 }} /> Return to Previous
                </p>
              </Button>
            </Col>
          </Row>
        </Box>
      </Box>
      <Box height="100px" marginBottom="50px" />
      <Box position="absolute" bottom="50px" marginLeft="auto" marginRight="auto" left="0" right="0" minWidth="320px" paddingX={20}>
        <div style={{ textAlign: 'center'}}>
          <Link to="/privacy" style={styles.privacy}>{t('welcome:signIn.privacy')}</Link>
        </div>
      </Box>
    </Box>
  );
}

export default SignInSelect;
